import { SettingsContext } from "../../enums";

export enum RoleNames {
  Admin = "admin",
  Member = "member",
  Moderator = "moderator",
  Observer = "observer",
  Client = "client",
  Supervisor = "supervisor",
  Guest = "guest",
}

export enum ProjectRoles {
  Admin = "role::project_admin",
  Moderator = "role::project_operator",
  Observer = "role::project_observer",
  Client = "role::project_client",
}

export enum WorkspaceRoles {
  Supervisor = "role::workspace_supervisor",
  Member = "role::workspace_operator",
  Guest = "role::workspace_guest",
}

export const PROJECT_ROLE_NAMES = [
  RoleNames.Admin,
  RoleNames.Moderator,
  RoleNames.Observer,
  RoleNames.Client,
];

export const WORKSPACE_ROLE_NAMES = [
  RoleNames.Supervisor,
  RoleNames.Member,
  RoleNames.Guest,
];

export const getRolesForContext = (context: string) => {
  switch (context) {
    case SettingsContext.Workspace:
      return WORKSPACE_ROLE_NAMES;

    case SettingsContext.Project:
      return PROJECT_ROLE_NAMES;

    default:
      return [];
  }
};

export const getRoleNameByKey = (roleValue: string) => {
  switch (roleValue) {
    case WorkspaceRoles.Supervisor:
      return RoleNames.Supervisor;

    case WorkspaceRoles.Guest:
      return RoleNames.Guest;

    case WorkspaceRoles.Member:
      return RoleNames.Member;

    case ProjectRoles.Moderator:
      return RoleNames.Moderator;

    case ProjectRoles.Admin:
      return RoleNames.Admin;

    case ProjectRoles.Observer:
      return RoleNames.Observer;

    case ProjectRoles.Client:
      return RoleNames.Client;

    default:
      return "";
  }
};
